import RandingStyle4 from "../../randing/RandingStyle4";

function Randing159({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/060/250107_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/159/250107_02.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/159/5.jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/060/250107_04.jpg`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton3.png`}
      formFieldColor="white"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      benefitInfoPosition="bottom"
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing159;
